import { Box, FormControl, Grid, Typography } from "@mui/material";
import styles from "../reportSection.module.scss";
import {
  CommonButton,
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  CustomMenuItem,
  CustomRequiredInputLabel,
  CustomSelectforFamily,
  StyledDateContainer,
  CustomInputLabel,
  CustomTextFeildforFamily,
  CommonOutlinedButton,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import { useState, useEffect } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { apiRequest } from "../../../infrastructure/backendService";
import { donationTypesProps } from "../../../infrastructure/GlobalContextProvider";
import apiPath from "../../../config/apiPaths.json";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import { ValidationError, object, string } from "yup";

interface ErrorMessageTypes {
  amount: string;
  searchCriteria: string;
  amountUpperLimit:string;
}
const currentYear = dayjs().year();
const formFields = {
  searchByDonationDateFrom: dayjs(`01-01-${currentYear}`).format('MM-DD-YYYY'),
  searchByDonationDateTo: dayjs().format("MM-DD-YYYY"),
  searchCriteria: "",
  amount: "",
  amountUpperLimit: "",
  donationTypeId: "",
  city: "",
  zipcode: "",
};

const DonationReportForDevoteeInformation = ({
  sendDataToParent,
  getReportData,
}: any) => {
  const [formData, setFormData] = useState(formFields);

  const [donationTypes, setDonationTypes] = useState<donationTypesProps[]>([]);

  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    amount: "",
    searchCriteria: "",
    amountUpperLimit:""
  });

  const validationSchema = object().shape({
    amount: string().required("Amount is required"),
    searchCriteria: string().required("Search Criteria is required"),
    amountUpperLimit:formData.searchCriteria === "><" ? string().required("This field is Required") : string()
  });

  const searchCriteria = ["<=", ">=", "=", "><"];

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.purposeOfDonations,
      includeToken: true,
    })
      .then((res) => {
        setDonationTypes(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleFieldChange = (field: any, value: any) => {
    if (field === 'searchByDonationDateFrom' || field === 'searchByDonationDateTo') {
      const formattedDate = dayjs(value, 'MM-DD-YYYY');
      setFormData({
          ...formData,
          [field]: formattedDate.isValid() ? formattedDate.format('MM-DD-YYYY') : '',
      });
    }else{  
       setFormData({
        ...formData,
        [field]: value,
      });
    }
  };

  const DonationforDevoteeInformationApiCall = () => {
    const reqBody = {
      ...(formData.searchByDonationDateFrom && { searchStartDate: formData.searchByDonationDateFrom}),
      ...(formData.searchByDonationDateTo && { searchEndDate: formData.searchByDonationDateTo}),
      pagination: true,
      pageNumber: 1,
      ...(formData.city && { city: formData.city }),
      ...(formData.donationTypeId && { donationsPurposeId: formData.donationTypeId }),
      ...(formData.zipcode && { zipCode: formData.zipcode }),
      ...(formData.amount && { searchAmount: formData.amount }),
      ...(formData.searchCriteria && { filterCondition: formData.searchCriteria}),
      ...(formData.searchCriteria === "><" && { searchAmountUpperLimit: formData.amountUpperLimit}),
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint:
        "/report-dashboard/reports/DONATION_REPORT_FOR_DEVOTEE_INFORMATION/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false);
        sendDataToParent(true, {reqBody,
          totalDonatedAmount:res.data.totalDonatedAmount,
          totalDrillDownData:res.data,
          formData});
        let counter = 1;
        const response = res.data.data.map((userInfo: any) => {
          return {
            "Sr No": counter++,
            "Sign-in Name": userInfo.username,
            "First Name": userInfo.firstname,
            "Last Name": userInfo.lastname,
            Address: `${userInfo.address || "-"} ${userInfo.city || "-"} ${userInfo.state || "-"} - ${userInfo.zipcode || "-"} ${userInfo.country || "-"} `,
            City: userInfo.city,
            "Zip code": userInfo.zipcode,
            "Home Phone": userInfo.phoneresidence,
            "Work Phone": userInfo.phonework,
            Email: userInfo.email,
            "Donation Amount": formatAmount(userInfo.donationamount),
            "Refund Amount": formatAmount(userInfo.refundamount),
          };
        });
        getReportData(response);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleSave = async (): Promise<any> => {
    const errors: ErrorMessageTypes = {
      amount: "",
      searchCriteria: "",
      amountUpperLimit:""
    };
    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      // Call your API or perform other actions here
      DonationforDevoteeInformationApiCall();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const DatePickerFromSearch = (): React.ReactElement => {
    return (
      <Box className={styles.dateconatiner}>
        <StyledDateContainer className={styles.styledConatiner}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formFields.searchByDonationDateFrom
                    ? dayjs(formFields.searchByDonationDateFrom, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  handleFieldChange("searchByDonationDateFrom", value);
                }}
                disableFuture
                className={styles.dateFeildforfamily}
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </Box>
    );
  };

  const DatePickerToSearch = (): React.ReactElement => {
    return (
      <Box className={styles.dateconatiner}>
        <StyledDateContainer className={styles.styledConatiner}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formFields.searchByDonationDateTo
                    ? dayjs(formFields.searchByDonationDateTo, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  handleFieldChange("searchByDonationDateTo", value);
                }}
                disableFuture
                className={styles.dateFeildforfamily}
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </Box>
    );
  };

  const DonationTypeDropdownList = (): React.ReactElement => {
    return (
      <>
        <FormControl className={styles.moveToDropdown}>
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            value={formData.donationTypeId}
            onChange={(e) => {
              handleFieldChange("donationTypeId", e.target.value);
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
          >
            {donationTypes.map((item: any, i: any) => (
              <CustomMenuItem value={item.accountNumber} key={i}>
                {item.accountDescription}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
      </>
    );
  };

  const SelectCriteriaDropDown = (): React.ReactElement => {
    return (
      <>
        <FormControl className={styles.moveToDropdown}>
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            value={formData.searchCriteria}
            onChange={(e) => {
              handleFieldChange("searchCriteria", e.target.value);
              setErrorMessage({ ...errorMessage, searchCriteria: "",amountUpperLimit:"" });
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
          >
            {searchCriteria.map((criteria: any, index: any) => (
              <CustomMenuItem value={criteria} key={index}>
                {criteria}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
      </>
    );
  };

  const handleClear = () => {
    setFormData(formFields);
  };

  return (
    <>
      <Box>
        <Grid container spacing={2} sx={{ mt: 0 }}>
          <Grid item xs={12} sm={4}>
            {CustomRequiredInputLabel("Search By Donation Date From", true)}
            {DatePickerFromSearch()}
          </Grid>
          <Grid item xs={12} sm={4}>
            {CustomRequiredInputLabel("Search By Donation Date To", true)}
            {DatePickerToSearch()}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ mt: 0 }}>
          <Grid item xs={12} sm={4}>
            {CustomRequiredInputLabel("Search By Donation Type", false)}
            {DonationTypeDropdownList()}
          </Grid>
          <Grid item xs={12} sm={4}>
            {CustomRequiredInputLabel("City", false)}
            <CustomTextFeildforFamily
              style={{ minWidth: "100%", borderRadius: "8px" }}
              id="city"
              fullWidth
              required
              value={formData.city}
              onChange={(e) => {
                handleFieldChange("city", e.target.value);
              }}
              className={styles.dateFeildforfamily}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ mt: 0 }}>
          <Grid item xs={12} sm={4}>
            {CustomRequiredInputLabel("Zipcode", false)}
            <CustomTextFeildforFamily
              style={{ minWidth: "100%", borderRadius: "8px" }}
              id="zipcode"
              fullWidth
              required
              value={formData.zipcode}
              onChange={(e) => {
                handleFieldChange("zipcode", e.target.value);
              }}
              className={styles.dateFeildforfamily}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            {CustomRequiredInputLabel("Search Criteria", true)}
            {SelectCriteriaDropDown()}
            {errorMessage.searchCriteria ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.searchCriteria}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ marginTop: "0px" }}>
          <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Amount", true)}
            <CustomTextFeildforFamily
              style={{ minWidth: "100%", borderRadius: "8px" }}
              fullWidth
              value={formData.amount}
              onChange={(e) => {
                const inputValue = e.target.value;
                handleFieldChange("amount", inputValue);
                setErrorMessage({ ...errorMessage, amount: "" });
              }}
              className={styles.dateFeildforfamily}
            />
            {errorMessage.amount ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.amount}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid item xs={12} sm={4}>
            <CustomInputLabel>
              If you have selected {"><"} search criteria, enter higher amount
              here
            </CustomInputLabel>
            <CustomTextFeildforFamily
              style={{ minWidth: "100%", borderRadius: "8px" }}
              fullWidth
              value={formData.amountUpperLimit}
              onChange={(e) => {
                const inputValue = e.target.value;
                handleFieldChange("amountUpperLimit", inputValue);
                setErrorMessage({ ...errorMessage, amountUpperLimit: "" });
              }}
              className={styles.dateFeildforfamily}
            />
             {errorMessage.amountUpperLimit ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.amountUpperLimit}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
        <Grid sx={{ mt: 3, display: "flex", gap: "1rem" }}>
          <CommonButton
            sx={{ width: "fit-content", height: "38px" }}
            onClick={handleSave}
            disabled={loading}
            id="submit"
          >
            <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
          </CommonButton>
          <CommonOutlinedButton onClick={handleClear}>
            Reset
          </CommonOutlinedButton>
        </Grid>
      </Box>
    </>
  );
};
export default DonationReportForDevoteeInformation;
